import React from 'react';
import { AppModule } from '../../core';
import { SimulatorLayout } from './layouts';
import SimulationWrapper from './pages/simulation-wrapper';

const simulatorModule: AppModule = {
  routes: [
    {
      path: '/session/:sessionId',
      page: SimulationWrapper,
      routes: [
        {
          path: '/session/:sessionId/simulator',
          layout: SimulatorLayout,
          topBar: true,
          page: React.lazy(() => import('./pages/simulator')),
        },
        {
          path: '/session/:sessionId/image-viewer',
          layout: SimulatorLayout,
          page: React.lazy(() => import('./pages/image-viewer')),
        },
        {
          path: '/session/:sessionId/k-space',
          exact: true,
          layout: SimulatorLayout,
          page: React.lazy(() => import('./pages/k-space')),
        },
      ],
    },
  ],
};

export default simulatorModule;
